import i18n from 'helpers/i18n';
import messages from './messages';
import CheckBox from 'components/CheckBox';
import { Text } from '@teachstonellc/component-library';

interface HonorCodeAgreementContentProps {
  setHonorCode: (value: boolean) => void;
  testType?: string;
}
function HonorCodeAgreementContent({
  setHonorCode,
  testType = 'knowledge'
}: HonorCodeAgreementContentProps) {
  return (
    <div className="text-lg">
      <div>
        <p>
          {i18n.ft(
            testType === 'calibration'
              ? messages.calibrationDescription
              : messages.description
          )}
        </p>
        <Text as="h3" className="py-4">
          {i18n.ft(messages.agree)}
        </Text>
        <ul className="list-disc ms-6 marker:text-orange-400">
          <li className="mb-4 mr-2">
            <div className="flex items-start ml-2">
              {i18n.ft(
                testType === 'calibration'
                  ? messages.completeCalibration
                  : messages.takeTest
              )}
            </div>
          </li>
          <li className="mb-4 mr-2">
            <div className="flex items-start ml-2">
              {i18n.ft(
                testType === 'calibration'
                  ? messages.priorCalibration
                  : messages.priorTaking
              )}
            </div>
          </li>
          <li className="mb-4 mr-2">
            <div className="flex items-start ml-2">
              {i18n.ft(
                testType === 'calibration'
                  ? messages.afterCalibration
                  : messages.afterTaking
              )}
            </div>
          </li>
        </ul>
      </div>
      <CheckBox
        id={`honorCodeAgreementCheckbox`}
        label={i18n.ft(
          testType === 'calibration'
            ? messages.calibrationCheckbox
            : messages.checkbox
        )}
        handleChange={e => setHonorCode(e.target.checked)}
      />
    </div>
  );
}

export default HonorCodeAgreementContent;
